export default "__VITE_ASSET__xnB9IsAn__"